import { createSlice } from '@reduxjs/toolkit'

const initialState = {
 
  categoryData: null,
  subCategoryData: {},
  allCategoriesLoading: false,
  allCategoriesSuccess: null,
  allCategoriesError: '',
  getCategoryLoading: false,
  getCategorySuccess: null,
  getCategoryError: '',
  allSubCategoriesLoading: false,
  allSubCategoriesSuccess: null,
  allSubCategoriesError: '',
  termGoal: [],
  favouriteCategory: [],
  favouriteSubCategory: [],
  createCategoryLoading: false,
  createCategorySuccess: {},
  createCategoryError: null,
  categoriesSuccess: {},
  categoriesError: null,
  courseTypeSuccess: {},
  courseTypeError: null
}

export const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    categoryManagement: (state, action) => {
      state.categoryData = action.payload;
    },
    createSubCatData: (state, action) => {
      state.subCategoryData = action.payload
    },
    setAllCategoriesLoading: (state, action) => {
      state.allCategoriesLoading = true;
      state.allCategoriesSuccess = null;
      state.allCategoriesError = '';
    },
    setAllCategoriesSuccess: (state, action) => {
      state.allCategoriesLoading = false;
      state.allCategoriesSuccess = action.payload;
      state.allCategoriesError = '';
    },
    setAllCategoriesError: (state, action) => {
      state.allCategoriesLoading = false;
      state.allCategoriesSuccess = null;
      state.allCategoriesError = action.payload;
    },
    setCreateCategoryLoading: (state) => {
      state.createCategoryLoading = true;
      state.createCategorySuccess = null;
      state.createCategoryError = '';
    },
    setCreateCategorySuccess: (state, action) => {
      state.createCategoryLoading = false;
      state.createCategorySuccess = action.payload;
      state.createCategoryError = '';
    },
    setCreateCategoryError: (state, action) => {
      state.createCategoryLoading = false;
      state.createCategorySuccess = null;
      state.createCategoryError = action.payload;
    },
    setGetCategoryLoading: (state) => {
      state.getCategoryLoading = true;
      state.getCategorySuccess = null;
      state.getCategoryError = "";
    },
    setGetCategorySuccess: (state, action) => {
      state.getCategoryLoading = false;
      state.getCategorySuccess = action.payload;
      state.getCategoryError = '';
    },
    setGetCategoryError: (state, action) => {
      state.getCategoryLoading = false;
      state.getCategorySuccess = null;
      state.getCategoryError = action.payload;
    },
    setAllSubCategoriesLoading: (state) => {
      state.allSubCategoriesLoading = true;
      state.allSubCategoriesSuccess = null;
      state.allSubCategoriesError = '';
    },
    setAllSubCategoriesSuccess: (state, action) => {
      state.allSubCategoriesLoading = false;
      state.allSubCategoriesSuccess = action.payload;
      state.allSubCategoriesError = '';
    },
    setAllSubCategoriesError: (state, action) => {
      state.allSubCategoriesLoading = false;
      state.allSubCategoriesSuccess = null;
      state.allSubCategoriesError = action.payload;
    },
    setCategoriesSuccess: (state, action) => {
      state.categoriesSuccess = action.payload;
      state.categoriesError = '';
    },
    setCategoriesError: (state, action) => {
      state.categoriesSuccess = null;
      state.categoriesError = action.payload;
    },
    setCourseTypeSuccess: (state, action) => {
      state.courseTypeSuccess = action.payload;
      state.courseTypeError = '';
    },
    setCourseTypeError: (state, action) => {
      state.courseTypeSuccess = null;
      state.courseTypeError = action.payload;
    },
    resetCreateCategory: (state) => {
      state.createCategoryLoading = false;
      state.createCategorySuccess = null;
      state.createCategoryError = '';
      state.getCategoryLoading = false;
      state.getCategorySuccess = null;
      state.getCategoryError = '';
    },
    resetAllCategories: (state) => {
      state.allCategoriesLoading = false;
      state.allCategoriesSuccess = null;
      state.allCategoriesError = '';
    },
    setTermGoal: (state, action) => {
      state.termGoal = action.payload;
    },
    setFavouriteCategory: (state, action) => {
      state.favouriteCategory = action.payload;
    },


    resetFavouriteCategory: (state, action) => {
      state.favouriteCategory = '';
    },
    setFavouriteSubCategory: (state, action) => {
      state.favouriteSubCategory = action.payload
    },
    resetFavouriteSubCategory: (state, action) => {
      state.favouriteSubCategory = ''
    }
  },
})

// Action creators are generated for each case reducer function
export const { setTermGoal, resetFavouriteCategory, resetFavouriteSubCategory, categoryManagement, createSubCatData, setAllCategoriesLoading, setAllCategoriesSuccess, setAllCategoriesError, setCreateCategoryLoading, setCreateCategorySuccess, setCreateCategoryError, setGetCategoryLoading, setGetCategorySuccess, setGetCategoryError, resetCreateCategory, resetAllCategories, setAllSubCategoriesLoading, setAllSubCategoriesSuccess, setAllSubCategoriesError, setFavouriteCategory, setFavouriteSubCategory, setCategoriesSuccess, setCategoriesError,setCourseTypeSuccess, setCourseTypeError

} = categorySlice.actions

export default categorySlice.reducer;